import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { KeepContactScreen, ContactSearch } from '@screens';
import AddKeep from '../../screens/menu/keepContact/AddKeep';
import { ContactListItem } from '@utils';
import { KeepContact as KeepContactType } from '@store';

export type KeepContactStackParamList = {
  KeepContactMain: {
    contactId?: string
  };
  ContactSearch: undefined;
  AddKeep: {
    contact?: ContactListItem;
    reminder?: KeepContactType;
  };
};

const Stack = createNativeStackNavigator<KeepContactStackParamList>();

const KeepContactStackNavigator: React.FC = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen 
        name="KeepContactMain" 
        component={KeepContactScreen} 
      />
      <Stack.Screen 
        name="ContactSearch" 
        component={ContactSearch} 
      />
      <Stack.Screen 
        name="AddKeep" 
        component={AddKeep} 
      />
    </Stack.Navigator>
  );
};

export default KeepContactStackNavigator; 